import Store from 'shared/store/Store'

import reducer from 'shared/store/ducks/reducers'
import { IState } from 'types/redux'

export { Store }
export { reducer }
export { subscribe } from './subscribe'

export default new Store<typeof reducer, IState>(reducer)
